'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exam = void 0;
const $ = require("jquery");
const ajax_1 = require("./ajax");
class Exam {
    constructor() {
        this.questions = [];
        this.currentIndex = 0;
        this.correctCount = 0;
        this.answers = [];
        this.labels = ['A', 'B', 'C', 'D'];
        this.ajax = new ajax_1.default();
        if (!$('.exam-quiz').length)
            return;
        const examData = window.examData;
        if (!examData || !examData.questions.length)
            return;
        this.questions = examData.questions;
        this.showQuestion(0);
        this.bindEvents();
    }
    showQuestion(index) {
        const q = this.questions[index];
        const total = this.questions.length;
        $('.exam-quiz__number').text(`Q${index + 1}/${total}`);
        const rate = q.view_count > 0
            ? Math.round(q.correct_count / q.view_count * 100)
            : 0;
        $('.exam-quiz__correct-rate').text(q.view_count > 0 ? `正解率: ${rate}%` : '正解率: -');
        $('.exam-quiz__question').text(q.question);
        // メディア表示
        const $mediaWrap = $('.exam-quiz__media-wrap');
        const $image = $('.exam-quiz__image');
        const $audio = $('.exam-quiz__audio');
        const $video = $('.exam-quiz__video');
        // 前の問題のメディアをリセット
        $image.attr('hidden', '').attr('src', '');
        $audio[0].pause();
        $audio.attr('hidden', '').attr('src', '');
        $video[0].pause();
        $video.attr('hidden', '').attr('src', '');
        if (q.movie) {
            $mediaWrap.removeAttr('hidden');
            $video.removeAttr('hidden').attr('src', q.movie);
        }
        else if (q.music) {
            $mediaWrap.removeAttr('hidden');
            $audio.removeAttr('hidden').attr('src', q.music);
        }
        else if (q.image) {
            $mediaWrap.removeAttr('hidden');
            $image.removeAttr('hidden').attr('src', q.image);
        }
        else {
            $mediaWrap.attr('hidden', '');
        }
        const $choices = $('.exam-quiz__choices').empty();
        q.options.forEach((option, i) => {
            $choices.append(`<li class="exam-quiz__choice" data-index="${i}" data-label="${this.labels[i]}">${option}</li>`);
        });
        $('.exam-quiz__judge').removeAttr('data-judge');
        $('.exam-quiz__next').attr('hidden', '');
        $('.exam-quiz').removeAttr('data-answered');
    }
    bindEvents() {
        const examData = window.examData;
        $(document).on('click', '.exam-quiz__choice', (e) => {
            const $quiz = $('.exam-quiz');
            if ($quiz.attr('data-answered') === 'true')
                return;
            $quiz.attr('data-answered', 'true');
            const $choice = $(e.currentTarget);
            const choiceIndex = parseInt($choice.attr('data-index') || '0', 10);
            const q = this.questions[this.currentIndex];
            const isCorrect = choiceIndex === q.correct;
            $choice.attr('data-is-selected', 'true');
            $('.exam-quiz__judge').attr('data-judge', isCorrect ? 'correct' : 'incorrect');
            this.answers.push(isCorrect);
            if (isCorrect)
                this.correctCount++;
            this.ajax.saveAnswer(q.post_id, isCorrect, examData.nonce, true);
            const isLast = this.currentIndex >= this.questions.length - 1;
            $('.exam-quiz__next')
                .text(isLast ? '結果へ' : '次の問題へ')
                .removeAttr('hidden');
        });
        $(document).on('click', '.exam-quiz__next', () => {
            this.currentIndex++;
            if (this.currentIndex < this.questions.length) {
                this.showQuestion(this.currentIndex);
            }
            else {
                this.showResult();
            }
        });
    }
    showResult() {
        const total = this.questions.length;
        const correct = this.correctCount;
        const rank = this.getRank(correct, total);
        $('.exam-result .exam-result__rank-value').text(rank).attr('data-rank', rank);
        $('.exam-result .exam-result__score-value').text(`${correct}/${total}`);
        const $list = $('.exam-result__list').empty();
        this.answers.forEach((isCorrect, i) => {
            $list.append(`<li class="exam-result__item">
                    <span class="exam-result__q">Q${i + 1}</span>
                    <span class="exam-result__mark" data-result="${isCorrect ? 'correct' : 'incorrect'}">${isCorrect ? '○' : '×'}</span>
                </li>`);
        });
        const shareText = encodeURIComponent(`沖縄クイズ試験モードで${total}問中${correct}問正解しました！ランクは「${rank}」でした #みしかの沖縄クイズ`);
        const pageUrl = encodeURIComponent(window.location.href);
        $('.js-share-x').attr('href', `https://x.com/intent/tweet?text=${shareText}&url=${pageUrl}`);
        $('.js-share-fb').attr('href', `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`);
        $('.js-mishika-comment').text(this.getMishikaComment(correct, total));
        $('.exam-quiz').attr('hidden', '');
        $('.exam-result').removeAttr('hidden');
    }
    getRank(correct, total) {
        const ratio = correct / total;
        if (ratio === 1)
            return 'SS';
        if (ratio >= 0.9)
            return 'S';
        if (ratio >= 0.7)
            return 'A';
        if (ratio >= 0.5)
            return 'B';
        if (ratio >= 0.3)
            return 'C';
        return 'D';
    }
    getMishikaComment(correct, total) {
        const ratio = correct / total;
        if (ratio === 1)
            return '全問正解！さすがやねぇ〜！';
        if (ratio >= 0.8)
            return 'すごいねぇ！もう少しで満点やよ！';
        if (ratio >= 0.6)
            return 'まあまあやねぇ。もう一回挑戦してみてよ！';
        if (ratio >= 0.4)
            return '半分は正解やよ。まだまだ修行が足りないねぇ〜';
        return 'あらあら...。次はもっとがんばってよね〜！';
    }
}
exports.Exam = Exam;
exports.default = Exam;
